module.exports = __webpack_public_path__ + "static/media/light-divider.94546a6d.png";